import React, { useEffect, useState } from 'react';
const SplashScreen = () => {
  const [text, setText] = useState('');
  const [showLogo, setShowLogo] = useState(false);
  const [showWhiteLogo, setShowWhiteLogo] = useState(true);
  const [fadingOut, setFadingOut] = useState(false);
  const fullText = '¡Ahora el agua ya no es una necesidad... sino una constante!';
  useEffect(() => {
    let currentIndex = 0;
    // Start with white logo visible
    setShowWhiteLogo(true);
    // Typewriter effect
    const typingInterval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setText(fullText.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        // Start text fade out after typing is complete
        setTimeout(() => {
          setFadingOut(true);
          setShowWhiteLogo(false);
          // Show colored logo after text fades out
          setTimeout(() => {
            setText('');
            setShowLogo(true);
          }, 1000);
        }, 1000);
      }
    }, 50);
    return () => clearInterval(typingInterval);
  }, []);
  return <div className="flex flex-col items-center justify-center w-full h-screen bg-[#146ead] text-white" data-id="element-183">
      <div className="flex flex-col items-center gap-8" data-id="element-184">
        {showWhiteLogo && <div className={`transition-opacity duration-1000 ${fadingOut ? 'opacity-0' : 'opacity-100'}`} data-id="element-185">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wycZwmE5h7LTqLVk6MHXQi/WATERFLOW_LOGO_BLANCO.png" alt="Guaterflow Logo Blanco" className="w-48 md:w-64 lg:w-80" data-id="element-186" />
          </div>}
        {text && <div className={`text-center text-2xl md:text-3xl lg:text-4xl font-medium transition-opacity duration-1000 ${fadingOut ? 'opacity-0' : 'opacity-100'}`} data-id="element-187">
            {text}
            <span className="animate-pulse" data-id="element-188">|</span>
          </div>}
      </div>
      {showLogo && <div className="animate-[fadeIn_1s_ease-in-out] transform transition-all scale-100 hover:scale-105" data-id="element-189">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hYfcvFkA5ig3Y9Rk5E8PSp/LOGO_LANDING.png" alt="Guaterflow Logo" className="w-64 md:w-80 lg:w-96" data-id="element-190" />
        </div>}
    </div>;
};
export default SplashScreen;